import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import DescriptionIcon from '@mui/icons-material/Description';
import LayersIcon from '@mui/icons-material/Layers';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import RouteIcon from '@mui/icons-material/Route';
import TuneIcon from '@mui/icons-material/Tune';
import { Box } from '@mui/material';

import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';

import { ConfigureModuleCard } from './ConfigureModuleCard';
import { useConfigurePage } from '../hooks/useConfigurePage';
import {
  CONFIGURE_RESOURCE_CALENDAR,
  CONFIGURE_RESOURCE_CONTENT,
  CONFIGURE_RESOURCE_NURTURING_JOURNEY,
  CONFIGURE_RESOURCE_SEGMENT_MESSAGE_TYPE_FOCUS,
  CONFIGURE_RESOURCE_SEGMENTS,
  CONFIGURE_RESOURCE_STATIC_VALUE_MESSAGES,
  CONFIGURE_RESOURCE_TEMPLATE_VALUE_PREFERENCES,
} from '../utils/configureResourceIds';

const ContentCardInner = () => {
  const { goToContent } = useConfigurePage();
  return (
    <ConfigureModuleCard
      title="Content"
      description="Manage content library for nurturing workflows"
      icon={<DescriptionIcon fontSize="small" />}
      onOpen={goToContent}
    />
  );
};

const CalendarCardInner = () => {
  const { goToCalendarConfiguration } = useConfigurePage();
  return (
    <ConfigureModuleCard
      title="Calendar"
      description="Configure timing, cadence, and blackout windows"
      icon={<CalendarTodayIcon fontSize="small" />}
      onOpen={goToCalendarConfiguration}
    />
  );
};

const SegmentsCardInner = () => {
  const { goToSegmentsConfiguration } = useConfigurePage();
  return (
    <ConfigureModuleCard
      title="Segments"
      description="Define and maintain audience segments"
      icon={<PeopleOutlineIcon fontSize="small" />}
      onOpen={goToSegmentsConfiguration}
    />
  );
};

const TemplateValueCardInner = () => {
  const { goToTemplateValuePreferences } = useConfigurePage();
  return (
    <ConfigureModuleCard
      title="Template Value Preferences"
      description="Set value-messaging preferences for templates"
      icon={<TuneIcon fontSize="small" />}
      onOpen={goToTemplateValuePreferences}
    />
  );
};

const SegmentMessageCardInner = () => {
  const { goToTemplateMessageTypeFocus } = useConfigurePage();
  return (
    <ConfigureModuleCard
      title="Segment Message Type Focus"
      description="Configure message type emphasis per segment"
      icon={<ChatBubbleOutlineIcon fontSize="small" />}
      onOpen={goToTemplateMessageTypeFocus}
    />
  );
};

const StaticValueCardInner = () => {
  const { goToStaticContentValueMessages } = useConfigurePage();
  return (
    <ConfigureModuleCard
      title="Static Content - Value Messages"
      description="Maintain static value-message content"
      icon={<LayersIcon fontSize="small" />}
      onOpen={goToStaticContentValueMessages}
    />
  );
};

const NurturingJourneyCardInner = () => {
  const { goToNurturingJourneySettings } = useConfigurePage();
  return (
    <ConfigureModuleCard
      title="Nurturing Journey"
      description="Manage nurturing journey steps, stages, and segments"
      icon={<RouteIcon fontSize="small" />}
      onOpen={goToNurturingJourneySettings}
    />
  );
};

const ProtectedContentCard = withResourceProtection(
  ContentCardInner,
  CONFIGURE_RESOURCE_CONTENT,
  null,
);
const ProtectedCalendarCard = withResourceProtection(
  CalendarCardInner,
  CONFIGURE_RESOURCE_CALENDAR,
  null,
);
const ProtectedSegmentsCard = withResourceProtection(
  SegmentsCardInner,
  CONFIGURE_RESOURCE_SEGMENTS,
  null,
);
const ProtectedTemplateValueCard = withResourceProtection(
  TemplateValueCardInner,
  CONFIGURE_RESOURCE_TEMPLATE_VALUE_PREFERENCES,
  null,
);
const ProtectedSegmentMessageCard = withResourceProtection(
  SegmentMessageCardInner,
  CONFIGURE_RESOURCE_SEGMENT_MESSAGE_TYPE_FOCUS,
  null,
);
const ProtectedStaticValueCard = withResourceProtection(
  StaticValueCardInner,
  CONFIGURE_RESOURCE_STATIC_VALUE_MESSAGES,
  null,
);
const ProtectedNurturingJourneyCard = withResourceProtection(
  NurturingJourneyCardInner,
  CONFIGURE_RESOURCE_NURTURING_JOURNEY,
  null,
);

export const ConfigureModules = () => {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, 1fr)',
          md: 'repeat(3, 1fr)',
        },
        gap: 3,
        width: '100%',
        maxWidth: 1200,
        mx: 'auto',
        alignContent: 'start',
      }}
    >
      <ProtectedContentCard />
      <ProtectedCalendarCard />
      <ProtectedSegmentsCard />
      <ProtectedTemplateValueCard />
      <ProtectedSegmentMessageCard />
      <ProtectedStaticValueCard />
      <ProtectedNurturingJourneyCard />
    </Box>
  );
};
